<!-- Choose company -->
<mat-card style="margin-top: 30px">
  <mat-card-content>
    @if (showProtocols) {
      <section class="fab-section">
        <div class="fab-row">
          <button
            #pushMigration
            mat-fab
            extended
            class="success-btn"
            (click)="publishMigrationClicked()"
            [disabled]="!shouldEnableMigrationCommands || loading"
            [class.gray-out]="!shouldEnableMigrationCommands || loading"
          >
            <mat-icon>arrow_circle_up</mat-icon>
            Push Migration
          </button>

          <button
            mat-fab
            extended
            class="warning-btn"
            (click)="rejectMigrationClicked()"
            [disabled]="!shouldEnableMigrationCommands || loading"
            [class.gray-out]="!shouldEnableMigrationCommands || loading"
          >
            <mat-icon>block</mat-icon>
            Reject Migration
          </button>
        </div>
      </section>
    }
    <app-search-select
      (selectionChange)="companySelectionChanged($event)"
      [loading]="loading"
    ></app-search-select>
  </mat-card-content>
  @if (company?.company_name && company?.has_irbnet_sites) {
    <mat-card-footer
      >*{{ company?.company_name }} has IRBNet sites
    </mat-card-footer>
  }
</mat-card>

<!-- Display protocols -->
@if (showProtocols) {
  <mat-card>
    <mat-card-content>
      <app-table-grid
        [data]="protocolsPaginated"
        [columnsLink]="columnsLink"
        (cellClicked)="protocolCellClicked($event)"
        [displayedColumns]="protocolsColumns"
        [headers]="protocolsTableHeaders"
        [columnWidths]="protocolsColumnWidths"
        [customStyle]="
          'font-family: monospace;font-size: 11px;max-width: 650px;'
        "
        [isLoading]="loadingTable"
        [skeletonRowsCount]="
          protocolsPaginated.length < paginatorFilter.pageSize
            ? protocolsPaginated.length
            : paginatorFilter.pageSize
        "
        [customBoolColumn]="'has_irbnet_sites'"
      ></app-table-grid>
      @if (protocols.length && !loading) {
        <mat-paginator
          showFirstLastButtons="true"
          [length]="paginatorFilter.count"
          [pageIndex]="paginatorFilter.currentPage"
          [pageSize]="paginatorFilter.pageSize"
          [pageSizeOptions]="[5, 10, 25, 100]"
          (page)="paginateProtocols($event)"
          class="mat-elevation-z8"
        >
        </mat-paginator>
      }
    </mat-card-content>
    @if (company?.company_name) {
      <mat-card-footer>
        *all protocols for {{ company?.company_name }}
      </mat-card-footer>
    }
  </mat-card>
}
